import React, { forwardRef, useState, useCallback } from "react";
import { rupees } from "./helper";
import { instance } from "./axios";
import { toast } from "react-toastify"
import { BgLoader, UiInput, UiButton } from "./ui";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useRazorpay from "react-razorpay";
import pgImg from "./pg.png";
import { AiOutlineExclamationCircle } from 'react-icons/ai'

export function PaymentForm(props) {

  const { pg, razorpay_key, name, mobile, company, cid, amount } = props
  const Razorpay = useRazorpay();
  const [loader, showLoader] = useState(false);
  const [state, setState] = useState({});



  const schema = yup.object().shape({
    amount: yup.string().nullable()
      .matches(/^[0-9.]+$/, "Enter amount")
      .min(1, "Enter amount"),
  });



  var validatePayment = (e) => {
  
    instance
      .get("/validate_cust_payment?id=" + e)
      .then(function (response) {
        if (response.data.status == 'success') {
          setState({ ...state, paydone: 1 })
          reset()
        }
        if (response.data.status == 'error') {
          toast(response.data.msg, { type: "error" })
        }
      })
  };



  const popupPay = (e) => {

    showLoader(true);
    const popname = window.open(e, "popname", "status=1,toolbar=0,resizable=0");
    popname.window.focus();
    var timer = setInterval(function () {
      if (popname.closed) {
        showLoader(false);
        clearInterval(timer);

      }
    }, 1000);
  }


  window.popupCallback = function (str) {
    showLoader(true)
    instance
      .get("/verify_cust_payment?id=" + str)
      .then(function (response) {
        showLoader(false)
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.status == "success") {
          setState({ ...state, paydone: 1 })
          reset()
        }
      })
  };


  const processPay = useCallback((e) => {

    showLoader(true)
    var form = document.querySelector("#payform");
    var data = new FormData(form);
    data.append('id', cid)

    instance({
      method: "post",
      url: "/cust_pay",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {

          if (pg == 'Razorpay') {
            const options: RazorpayOptions = {
              key: razorpay_key,
              amount: response.data.pay.amount,
              currency: "INR",
              name: company,
              description: "",
              order_id: response.data.pay.id,
              handler: (res) => {

                validatePayment(response.data.pay.id);
              },
              prefill: {
                name: name,

                contact: mobile,
              },


              theme: {
                color: "#0d6efd",
              },
            };

            const rzpay = new Razorpay(options);
            rzpay.open();
          } else if (pg == 'Phonepe') {
            popupPay(response.data.pay.id)
          }
        }
        if (response.data.status == 'error') {
          toast(response.data.msg, { type: "error" });
        }


      })
      .catch(function (response) { });
  }, [Razorpay]);




  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    processPay();

  };




  return (

    <>
      <div className="card card-default">
        <div className="card-body">
          {pg ?
            <>
              {state.paydone ?
                <>
                  <div className="wrapper"> <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" /> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                  </svg>

                  </div>
                  <p className="text-center fs-5">Payment success</p>
                </> :
                <form id="payform" onSubmit={handleSubmit(onSubmitHandler)}>

                  <p className="text-muted mb-3">Enter amount below and click on pay to make online payment to us.</p>
                  <UiInput
                    label="Amount"
                    type="text"
                    name="amount"
                    defaultValue={amount}
                    message={errors.amount?.message}
                    {...register("amount")}
                  />

                  <UiButton className="w-100 btn btn-lg btn-primary" loading={loader} title="Pay" />
                  <img src={pgImg} className="w-100 px-5 mt-3" />



                </form>

              }
            </>
            :
            <div className="text-center">
              <AiOutlineExclamationCircle className="fs-1 text-warning mb-4" />
              <p className="text-muted">Online payment is currently disabled!</p>
            </div>
          }
        </div>
      </div>
    </>

  )
}

